<template>
  <li
    class="input-select__results-item py-2 px-4"
    :class="{
      'input-select__results-item--selected': isSelected,
      'input-select__results-item--focused': isFocused,
    }"
    @click="onItemSelected"
  >
    {{ getItemLabel(item) }}
  </li>
</template>

<script lang="ts">
import { toRef } from 'vue-demi';
import useItemLabel from './composables/useItemLabel';

export default defineComponent({
  props: {
    item: {
      type: [Object],
      required: true,
    },
    labelKey: {
      type: String,
      required: false,
      default: 'label',
    },
    itemLabelFn: {
      type: Function as PropType<(item: unknown) => string>,
      required: false,
      default: undefined,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isFocused: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['item-selected'],
  setup(props, { emit }) {
    const labelKeyProp = toRef(props, 'labelKey');
    const itemProp = toRef(props, 'item');
    const getItemLabel = useItemLabel<unknown>(labelKeyProp, props.itemLabelFn);

    const onItemSelected = () => {
      emit('item-selected', itemProp.value);
    };

    return { getItemLabel, onItemSelected };
  },
});
</script>

<style scoped lang="scss">
@import 'gportal-theme/scss/colors';

.input-select__results-item {
  &:hover {
    background-color: rgba($gp-dark-mouse, 0.9);
    cursor: pointer;
  }

  &--focused,
  &:focus {
    background-color: rgba($gp-dark-mouse, 0.9);
  }

  &--selected {
    background-color: $gp-dark-mouse;
    &:hover {
      cursor: default;
    }
  }
}
</style>
